import React, { useState } from "react";
import { Box, TextField, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ChatInput = ({ onSend, disabled }) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    const trimmed = message.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: 1,
        p: 1.5,
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#fff",
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={3}
        size="small"
        placeholder="Ask me anything about HR..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "20px",
            fontSize: "0.875rem",
          },
        }}
        inputProps={{ maxLength: 1000 }}
      />
      <IconButton
        onClick={handleSend}
        disabled={!message.trim() || disabled}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          "&:hover": { backgroundColor: "#1565c0" },
          "&.Mui-disabled": { backgroundColor: "#e0e0e0", color: "#999" },
          width: 40,
          height: 40,
        }}
      >
        <SendIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Box>
  );
};

export default ChatInput;
